export default __webpack_public_path__ + "static/mat-8fa5f94dcea1ea2f32302c05fe62f9ea.svg";